import { ChevronsDown, ChevronsUp } from 'lucide-react'
import React from 'react'

import { cn } from '@/lib/utils'

const EscalationIcon = ({
  className,
  iconClassName,
  renderFooter,
  isResolved,
}: {
  className?: string
  iconClassName?: string
  renderFooter?: () => React.ReactNode
  isResolved?: boolean
}) => {
  const Icon = isResolved ? ChevronsDown : ChevronsUp
  return (
    <div
      className={cn(
        'grid size-[18px] place-items-center rounded-full bg-brand-secondary text-white',
        {
          'bg-base-accent text-muted-foreground': isResolved,
        },
        className,
      )}
    >
      <Icon className={cn('size-3 shrink-0', iconClassName)} />
      {renderFooter ? renderFooter() : null}
    </div>
  )
}
EscalationIcon.displayName = 'EscalationIcon'

const EscalationIconWithCount = ({
  count,
  className,
  countClassName,
  isResolved,
}: {
  count?: number
  className?: string
  countClassName?: string
  isResolved?: boolean
}) => {
  return (
    <EscalationIcon
      className={cn('flex w-fit items-center gap-0.5 px-2', className)}
      renderFooter={() => <span className={cn('text-sm font-medium leading-[18px]', countClassName)}>{count}</span>}
      isResolved={isResolved}
    />
  )
}
EscalationIconWithCount.displayName = 'EscalationIconWithCount'

export { EscalationIcon, EscalationIconWithCount }
